import React, { useMemo } from 'react';
import { Box } from '@mui/joy';
import { KPI, Scorecard } from 'src/mtska-frontend-app-component';
import List from './List';

const Default = () => {
    const date = new Date();
    const formattedDateToday = date.toISOString().split('T')[0];
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const formattedDateStartOfMonth = `${startOfMonth.getFullYear()}/${String(startOfMonth.getMonth() + 1).padStart(2, '0')}/${String(startOfMonth.getDate()).padStart(2, '0')}`;

    return <>

        {/* <Box className="mtska-chart-wrapper">
            <KPI
                title="Totale segmenti creati"
                icon="faLayerGroup"
                dataProviderName={'statistics/item/count/audiences/audiencedelivery'}
            />
            <KPI
                title={"Contatti per segmento"}
                icon="faChartBar"
                dataProviderName={'statistics/currentday/count/audiences/audiencedelivery'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': ''
                    }]
                }}
            />
            <KPI
                title={"Segmento più grande"}
                icon="faChartLineUp"
                dataProviderName={'statistics/currentday/count/audiences/audiencedelivery'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': ''
                    }]
                }}
            />
            <KPI
                title={"Segmenti attivi"}
                icon="faEye"
                dataProviderName={'statistics/currentday/count/audiences/audiencedelivery'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': ''
                    }]
                }}
            />
        </Box> */}

        <List />
    </>

}

export default Default;


